/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

export default ({ ref = null, shouldCheckResize = true, deps = [] }) => {
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = ref?.current;
    if (!el) return;

    const checkTruncation = () => {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    };

    checkTruncation();

    if (!shouldCheckResize) return;

    const observer = new ResizeObserver(() => checkTruncation());
    observer.observe(el);

    return () => observer.disconnect();
  }, [ref, shouldCheckResize, ...deps]);

  return isTruncated;
};
